import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, withStyles } from '@material-ui/core';
import { Button } from '@orijinworks/frontend-commons';
import CloudSyncRoundedIcon from '@mui/icons-material/CloudSyncRounded';
import styles from './facility-lms-bulk-bar.style';

const FacilityLmsBulkBar = ({
  classes,
  selectedCount,
  eligibleSelectedCount,
  estimatedLocationCount,
  eligibleOnPageCount,
  onProvisionSelected,
  onViewBulkJobs,
  onClearSelection,
  loading,
}) => {
  const hasSelection = selectedCount > 0;
  const showLocationEstimate =
    eligibleSelectedCount > 0 && estimatedLocationCount > eligibleSelectedCount;

  const selectionSummary = (() => {
    if (eligibleSelectedCount === 0) {
      return `${selectedCount} selected · none eligible to provision`;
    }
    if (showLocationEstimate) {
      return `${eligibleSelectedCount} facilit${eligibleSelectedCount === 1 ? 'y' : 'ies'} selected · ~${estimatedLocationCount} Canvas locations estimated`;
    }
    return `${selectedCount} selected · ${eligibleSelectedCount} eligible to provision`;
  })();

  return (
    <Box
      className={classes.bar}
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      data-testid="facility-lms-bulk-bar"
    >
      {hasSelection ? (
        <>
          <Typography variant="body2" className={classes.summary}>
            {selectionSummary}
          </Typography>
          <Box className={classes.actions}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              disabled={eligibleSelectedCount === 0 || loading}
              onClick={onProvisionSelected}
              data-testid="facility-lms-bulk-provision-btn"
              startIcon={<CloudSyncRoundedIcon />}
            >
              Provision selected to Canvas
            </Button>
            <Box marginLeft={1}>
              <Button
                color="default"
                variant="outlined"
                size="small"
                disabled={loading}
                onClick={onClearSelection}
                data-testid="facility-lms-clear-selection-btn"
              >
                Clear selection
              </Button>
            </Box>
          </Box>
        </>
      ) : (
        <Typography variant="body2" className={classes.hint}>
          Select facilities with checkboxes to bulk-provision Canvas subaccounts.
          {eligibleOnPageCount > 0
            ? ` ${eligibleOnPageCount} on this page can be provisioned.`
            : ' No eligible facilities on this page.'}
          {' Header select-all applies to the current page only.'}
        </Typography>
      )}
      <Box marginLeft="auto">
        <Button
          color="default"
          variant="text"
          size="small"
          onClick={onViewBulkJobs}
          data-testid="facility-lms-bulk-jobs-open"
        >
          View bulk provisioning jobs
        </Button>
      </Box>
    </Box>
  );
};

FacilityLmsBulkBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  eligibleSelectedCount: PropTypes.number.isRequired,
  estimatedLocationCount: PropTypes.number,
  eligibleOnPageCount: PropTypes.number.isRequired,
  onProvisionSelected: PropTypes.func.isRequired,
  onViewBulkJobs: PropTypes.func.isRequired,
  onClearSelection: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

FacilityLmsBulkBar.defaultProps = {
  loading: false,
  estimatedLocationCount: 0,
};

export default withStyles(styles)(FacilityLmsBulkBar);
